var React = require('react');

function IcPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.9498 12.7074L20.4853 9.17188L21.1924 9.87899C21.5813 10.2679 22.2177 10.2679 22.6066 9.87899C22.9955 9.49008 22.9955 8.85368 22.6066 8.46477L15.5356 1.39371C15.1466 1.0048 14.5102 1.0048 14.1213 1.39371C13.7324 1.78261 13.7324 2.41901 14.1213 2.80792L14.8284 3.51503L11.2929 7.05056C10.1191 8.22436 8.22407 8.22436 7.05027 7.05056L5.63606 8.46477L9.85748 12.6862L4.90774 17.6359V19.0502H6.32195L11.2717 14.1004L15.5356 18.3643L16.9498 16.9501C15.776 15.7763 15.776 13.8812 16.9498 12.7074Z","fill":"currentColor"}));
}

IcPin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcPin;

IcPin.default = IcPin;
